// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"195":"90c91fa3","705":"7b3cf29d","762":"8442fc9c","803":"7b3cf29d"}[chunkId] + ".chunk.css";
};